import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "TutorialModal" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("閉じる")

import UITitle from "../ui/UITitle.vue";
import UIButton from "../ui/UIButton.vue";
import UIExplain from "../ui/UIExplain.vue";



export default /*#__PURE__*/_defineComponent({
  emits: ["onClickClose"],
  setup(__props, { emit: emits }) {

const title = "チュートリアル";
const explain =
	"あなたのMAX重量を入力すると各トレーニングプログラムに適したメニューが自動で生成されます。<br />＊ベンチプレス、スクワット、デッドリフトのBIG3向けです。<br />このアプリケーションを使うことでトレーニング時の重量計算という煩わしさから解放されます。";


const onClickClose = () => {
	emits("onClickClose", false);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(UITitle, {
      title: title,
      titleType: "sub"
    }),
    _createVNode(UIExplain, { explain: explain }),
    _createVNode(UIButton, {
      class: "TutorialModal-Button",
      size: "medium",
      onClick: onClickClose
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    })
  ]))
}
}

})